import React, { Component } from 'react'
import RoleControlled from '../../_common/RoleControlled'
import { deleteMsg } from '../../../const'

class InfoItem extends Component {
  constructor (props) {
    super(props)

    this.state = {
      edit: false,
      defaultName: this.props.info.store_name,
      defaultTel: this.props.info.store_telno,
      defaultOpen: this.props.info.open,
      defaultAddress: this.props.info.store_address,
      defaultUrl: this.props.info.store_url,
      defaultVideoUrl: this.props.info.video_link,
      defaultImageUrl: this.props.info.image_url,
      store_name: this.props.info.store_name,
      store_telno: this.props.info.store_telno,
      open: this.props.info.open,
      store_address: this.props.info.store_address,
      store_url: this.props.info.store_url,
      video_link: this.props.info.video_link,
      image_url: this.props.info.image_url,
      image: '',
      image_error: ''
    }
  }

  _handleEditClick () {
    this.setState({ edit: true })
  }
  _handleDeleteClick () {
    const res = window.confirm(deleteMsg)
    if (res) {
      this.props.deleteData(this.props.info.id)
    }
  }

  _handleSaveClick () {
    const {
      store_name,
      store_telno,
      open,
      store_address,
      store_url,
      video_link,
      image
    } = this.state
    const data = {
      id: this.props.info.id,
      store_name,
      store_telno,
      open,
      store_address,
      store_url,
      video_link
    }
    this.props.saveData(data, image)
    this.setState({ edit: false })
  }
  _handleCancelClick () {
    this.setState({
      edit: false,
      store_name: this.state.defaultName,
      store_telno: this.state.defaultTel,
      open: this.state.defaultOpen,
      store_address: this.state.defaultAddress,
      store_url: this.state.defaultUrl,
      imageBase64: this.state.defaultImageBase64,
      img: '',
      image_error: ''
    })
  }

  _handleImageChange = (e) => {
    const image = e.target.files[0]
    if (image) {
      if (
        (image.type === 'image/png' || image.type === 'image/jpeg' || image.type === 'image/jpeg') &&
        (image.name.indexOf('png') > 0 || image.name.indexOf('jpeg') > 0 || image.name.indexOf('jpg') > 0)
      ) {
        let reader = new FileReader()
        reader.onload = (e) => {
          this.setState({image_url: e.target.result})
        }
        reader.readAsDataURL(e.target.files[0])
        this.setState({ image })
      } else {
        this.setState({ image_error: '画像ファイル外を選択しました。\n確認の上でもう一度画像ファイルを選択してください。' })
      }
    }
  }

  _handleUpdateContent (key, e) {
    this.setState({ [key]: e.target.value })
  }

  _resetImage () {
    this.setState({ image: '', image_url: '' })
    document.getElementById(`image_${this.props.info.id}`).value = ''
  }

  _renderImageLabel () {
    if (this.state.edit) {
      if (this.state.image_url) {
        return (
          <div className="label_container">
            <label className="image_input_label image_selected" htmlFor={`image_${this.props.info.id}`}>
              <img className="img-responsive" src={this.state.image_url} alt=""/>
            </label>
            <div className="delete_container" onClick={this._resetImage.bind(this)}>
              <span></span>
              <span></span>
            </div>
          </div>
        )
      }
      return (
        <div className="label_container">
          <label className="image_input_label image_blank" htmlFor="image">
            <svg className="add" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" >
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="16"></line>
              <line x1="8" y1="12" x2="16" y2="12"></line>
            </svg>
          </label>
        </div>
      )
    }
    return (
      <div className="label_container">
        <div className="image_input_label image_selected show" htmlFor="image">
          <img className="img-responsive" src={this.state.image_url} alt=""/>
        </div>
      </div>
    )
  }

  _renderTopBlock () {
    if (this.state.edit) {
      return (
        <div className="top_block">
          <div className="input_group">
            <label htmlFor="name">タイトル</label>
            <input type="text" value={ this.state.store_name } onChange={ this._handleUpdateContent.bind(this, 'store_name') }/>
          </div>
          <div className="input_group">
            <label htmlFor="tel">電話番号</label>
            <input type="text" value={ this.state.store_telno } onChange={ this._handleUpdateContent.bind(this, 'store_telno') }/>
          </div>
          <div className="input_group">
            <label htmlFor="open">営業時間</label>
            <input type="text" value={ this.state.open } onChange={ this._handleUpdateContent.bind(this, 'open') }/>
          </div>
        </div>
      )
    }
    return (
      <div className="top_block">
        <div className="input_group">
          <label htmlFor="name">タイトル</label>
          <div className="value" >{ this.state.store_name }</div>
        </div>
        <div className="input_group">
          <label htmlFor="tel">電話番号</label>
          <div className="value" >{ this.state.store_telno }</div>
        </div>
        <div className="input_group">
          <label htmlFor="open">営業時間</label>
          <div className="value" >{ this.state.open }</div>
        </div>
      </div>
    )
  }
  _renderBottomBlock () {
    if (this.state.edit) {
      return (
        <div className="bottom_block edit_mode">
          <div className="input_group">
            <label htmlFor="address">住所</label>
            <input type="text" value={ this.state.store_address } onChange={ this._handleUpdateContent.bind(this, 'store_address') }/>
          </div>
          <div className="input_group">
            <label htmlFor="url">ホームページURL</label>
            <input type="text" value={ this.state.store_url } onChange={ this._handleUpdateContent.bind(this, 'store_url') }/>
          </div>
          <div className="input_group">
            <label htmlFor="video">動画リンク</label>
            <input type="text" value={ this.state.video_link } onChange={ this._handleUpdateContent.bind(this, 'video_link') }/>
          </div>
        </div>
      )
    }
    return (
      <div className="bottom_block">
        <div className="input_group">
          <label htmlFor="address">住所</label>
          <a className="value" href={`https://www.google.com/maps/search/${this.state.store_address}`} target="_blank">{ String(this.state.store_address) }</a>
        </div>
        <div className="input_group">
          <label htmlFor="url">ホームページURL</label>
          <a className="value" href={this.state.store_url} target="_blank">{ this.state.store_url }</a>
        </div>
        <div className="input_group">
          <label htmlFor="video">動画リンク</label>
          <a className="value" href={this.state.video_link} target="_blank">{ this.state.video_link }</a>
        </div>
      </div>
    )
  }

  _renderBtns () {
    if (this.state.edit) {
      return [
        <button key="cancel" className="btn reverse_red" onClick={this._handleCancelClick.bind(this)}>キャンセル</button>,
        <button key="save" className="btn reverse_primary" onClick={this._handleSaveClick.bind(this)}>保存</button>
      ]
    }
    return [
      <button key="delete" className="btn red" onClick={this._handleDeleteClick.bind(this)}>削除</button>,
      <button key="edit" className="btn reverse_primary" onClick={this._handleEditClick.bind(this)}>編集</button>
    ]
  }

  render () {
    return (
      <article className="info">
        <div className="flex justify-between">
          <div className="info_inner admin_inner flex column">
            <div className="contents flex top_label">
              { this._renderTopBlock()}
            </div>
            <div className="contents flex bottom_label">
              { this._renderBottomBlock()}
            </div>
          </div>
          <div className="input-group flex column">
            <label className="label text-center" htmlFor={`image_${this.props.info.id}`}>
              画像
              {
                this.state.edit
                  ? <span className="smallest">（JPEG・PNGファイルのみ）</span>
                  : null
              }

            </label>
            <div className="image_input_container flex">
              { this._renderImageLabel() }
              <div>
                <div className="image_error small">{ this.state.image_error }</div>
                <input
                  type="file"
                  id={`image_${this.props.info.id}`}
                  onChange={this._handleImageChange}
                />
              </div>
            </div>
          </div>
        </div>
        <RoleControlled role={this.props.role} acceptedRoles={[0, 1]}>
          <div className="btn_group flex">
            { this._renderBtns() }
          </div>
        </RoleControlled>
      </article>
    )
  }
}

export default InfoItem



// WEBPACK FOOTER //
// ./src/components/Properties/NearbyInformations/InfoItem.js